import { css } from "@emotion/css";

export const containerStyle = css`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  color: #ffffff;
`;

export const contentStyle = css`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const sectionStyle = css`
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  padding: 32px;
  border: 1px solid rgba(255, 255, 255, 0.05);
`;

export const sectionTitleStyle = css`
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 24px 0;
`;

export const detailRowStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const detailLabelStyle = css`
  font-size: 14px;
  color: #adadad;
  font-weight: 500;
`;

export const detailValueStyle = css`
  font-size: 14px;
  color: #ffffff;
  font-weight: 500;
`;

export const transactionCardStyle = css`
  background: rgba(255, 255, 255, 0.02);
  border-radius: 8px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.05);
`;

export const productsGridStyle = css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
`;

export const loadingStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #ffffff;
  font-size: 16px;
`;

export const errorStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #f44336;
  font-size: 16px;
`;

export const sectionDividerStyle = css`
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 32px 0;
`;

export const subsectionTitleStyle = css`
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 20px 0;
`;

export const planCardStyle = css`
  background: rgba(255, 255, 255, 0.02);
  border-radius: 8px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.05);
`;

export const planHeaderStyle = css`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
`;

export const planNameStyle = css`
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
`;

export const bubbleTagStyle = css`
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  background: rgba(255,255,255,0.125);
  color: #fff;
`;

export const statusStyle = css`
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
`;

export const bottomRowStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  gap: 24px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

export const managementTextStyle = css`
  flex: 1;
  color: #adadad;
  font-size: 14px;
  line-height: 1.5;
  margin-right: 24px;
`;

export const chooseButtonStyle = css`
  background: #0f7dff;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: flex-start;

  &:hover {
    background: #0056cc;
  }
`;

export const manageButtonStyle = css`
  background: #6c757d;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: flex-start;

  &:hover {
    background: #5a6268;
  }
`;

export const adminButtonStyle = css`
  background: #dc3545;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: flex-start;

  &:hover {
    background: #c82333;
  }
`;

export const buttonContainerStyle = css`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
`;

export const appleBannerStyle = css`
  background: rgba(255, 149, 0, 0.1);
  border: 1px solid rgba(255, 149, 0, 0.3);
  border-radius: 12px;
  margin-bottom: 20px;
  overflow: hidden;
`;

export const appleBannerContentStyle = css`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
`;

export const appleBannerIconStyle = css`
  font-size: 32px;
  line-height: 1;
  margin-top: 4px;
`;

export const appleBannerTextStyle = css`
  flex: 1;
`;

export const appleBannerTitleStyle = css`
  font-size: 18px;
  font-weight: 600;
  color: #ff9500;
  margin: 0 0 8px 0;
`;

export const appleBannerMessageStyle = css`
  font-size: 14px;
  color: #ffffff;
  line-height: 1.5;
  margin: 0;
  opacity: 0.9;
`;